import styled from 'styled-components';
import { MEDIA_QUERY } from '@sky-distribution/react-commons-ui';
import { TENANT_NAME, Tenant } from '../../../config/tenants';

const isTuw = TENANT_NAME === Tenant.TUW;

export const InformationPageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const InformationPageContentWrapper = styled.div`
  font-family: 'Nunito', 'Roboto';
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  max-width: 928px;
`;

export const InformationPageTitleText = styled.div`
  font-size: ${isTuw ? '28px' : '3rem'};
  font-weight: 700;
  text-align: center;

  ${MEDIA_QUERY.below('sm')} {
    font-size: ${isTuw ? '28px' : '1.125rem'};
    margin: 1rem 0;
    text-align: start;
  }
`;

export const InformationPagePageMainText = styled.div`
  font-size: 1.5rem;
  text-align: center;
  white-space: wrap;
  font-weight: 400;

  ${MEDIA_QUERY.below('sm')} {
    font-size: 1rem;
    text-align: start;
  }
`;

export const InformationPageButtonsContainer = styled.div`
  max-width: 328px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 1.25rem;

  ${isTuw
    ? `
    max-width: 560px;
    flex-direction: row;

    > button {
      flex: 1;
    }
  `
    : ''}

  ${MEDIA_QUERY.below('sm')} {
    font-size: 1.125rem;
    ${isTuw ? 'max-width: 328px; flex-direction: column;' : ''}
  }
`;
